import { get, post, put, deleted } from '..';
import routes from './routes';

const SalePersonServices = {
  createSalePerson: async (obj) => {
    const data = await post(routes.createSalePerson, obj);
    return data;
  },
  getSalePersons: async (params) => {
    const data = await get(routes.getSalePersons, params);
    return data;
  },
  getSalePersonById: async (id) => {
    const data = await get(routes.getSalePersonById + id);
    return data;
  },
  updateSalePerson: async (id, obj) => {
    const data = await put(routes.updateSalePerson + id, obj);
    return data;
  },
  deleteSalePerson: async (id) => {
    const data = await deleted(routes.deleteSalePerson + id);
    return data;
  },
}

export default SalePersonServices